import { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, Checkbox, DashboardModule, ListItem,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useServiceCategories from '@hooks/useServiceCategories'

const handleToggle = (id, updateServiceProduct, toggleCategory) => {
  const updateServiceProductPayload = {
    callbacks: {
      action: toggleCategory,
    },
    entityParams: id,
    toastText: 'Product Updated',
  }

  updateServiceProduct(updateServiceProductPayload)
}

const Categories = (props) => {
  const { serviceProductPayload } = props

  const {
    callbacks: {
      toggleCategory,
    },
    serviceProduct,
  } = serviceProductPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateServiceProduct },
  } = pageContext

  const {
    filteredServiceCategories,
  } = useServiceCategories({ performHttpRequests: true })

  const assignedCategories = digObject(serviceProduct, 'options.categories', [])

  return (
    <DashboardModule title="Categories">
      <Box flexDirection="column" padding="large">
        {filteredServiceCategories.map((serviceCategory) => {
          const { id, title } = serviceCategory

          return (
            <ListItem.WithCheckbox
              boxProps={{ border: 'none' }}
              checkbox={(
                <Checkbox
                  checked={assignedCategories.includes(id)}
                  onClick={() => handleToggle(id, updateServiceProduct, toggleCategory)}
                />
              )}
              disableHover
              key={id}
            >
              <Box color="bodyFontColor" fontSize="small">
                {title}
              </Box>
            </ListItem.WithCheckbox>
          )
        })}
      </Box>
    </DashboardModule>
  )
}

Categories.propTypes = {
  serviceProductPayload: PropTypes.object.isRequired,
}

export default Categories
